import React from 'react';
import { useSelector } from 'react-redux';
import { SkeletonTable, SkeletonText } from 'ui/components/skeleton';

export const Item = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Fulfillment.Show']
  );

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3" id="items">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Rincian Item'
        )}
      </div>

      <div className="pt-2">
        {StateLoading ? (
          <SkeletonTable headerCount={3} bodyCount={4} />
        ) : (
          <div className="table-responsive">
            <table
              width="100%"
              className="table table-hover table-vcenter card-table datatable border"
            >
              <thead className="bg-light">
                <tr className="th">
                  <td style={{ whiteSpace: 'initial', width: '200px' }}>
                    Item
                  </td>
                  <td
                    style={{
                      whiteSpace: 'initial',
                      width: '200px',
                      textAlign: 'end',
                    }}
                  >
                    Quantity Planned
                  </td>
                  <td
                    style={{
                      whiteSpace: 'initial',
                      width: '200px',
                      textAlign: 'end',
                    }}
                  >
                    Quantity Fulfilled
                  </td>
                </tr>
              </thead>
              <tbody>
                {data?.items?.map((s, i) => (
                  <tr key={i}>
                    <td style={{ whiteSpace: 'initial', width: '200px' }}>
                      <div className="table-col text-uppercase">
                        <div className="fs-8 fw-semibold">
                          {s?.plan_item?.item?.alias_name}
                        </div>
                        <small className="info text-ellipsis">{s?.plan_item?.item?.code}</small>
                      </div>
                    </td>
                    <td
                      style={{
                        whiteSpace: 'initial',
                        width: '150px',
                        textAlign: 'end',
                      }}
                    >
                      <span className='fw-semibold fs-8 d-block'>{s?.quantity_planned} {s?.plan_item?.item?.default_fraction}</span>
                      <span className='fs-9 d-block'>{s?.quantity_planned_fracted}</span>
                    </td>
                    <td
                      style={{
                        whiteSpace: 'initial',
                        width: '150px',
                        textAlign: 'end',
                      }}
                    >
                      <span className={`fw-semibold fs-8 d-block ${(s?.quantity_planned !== s?.quantity_fulfilled) ? 'text-danger': 'text-success'}`}>{s?.quantity_fulfilled} {s?.plan_item?.item?.default_fraction}</span>
                      <span className='fs-9 d-block'>{s?.quantity_fulfilled_fracted}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};
